import React from "react";
import { Button, Col, Drawer, Row, Spin, message } from "antd";
import CaseLeegalityAgreementService from "../../services/case-leegality-agreement-service";
import CaseLeegalityService from "services/case-leegality-agreement-service"; 
import { sanitizeTemplateHtml } from "utilities/sanitize-html";



export  class LeegalityPreviewNewPage extends React.Component {
    state={
        loading: false,
        templateData: {}
    }
    componentDidMount() {
        this.setState({
            loading: true
        })
        const queryParams = new URLSearchParams(window.location.search);
        const jsonData = queryParams.get('payload');
        const data = JSON.parse(decodeURIComponent(jsonData));
        CaseLeegalityService.triggerAgreement(data, true).then((response) => {
            this.setState({
                templateData: response.data,
                loading: false
            } , () => {
                this.setData();

            });
        }).catch ((e)  => {
            this.setState({
                loading : false
            })
        })
    }

    detectMimeType(base64) {
        if (base64.startsWith("iVBORw0K") || base64.startsWith("/9j/")) {
            return "image"; // PNG or JPEG image
        } else if (base64.startsWith("JVBERi0")) {
            return "pdf"; // PDF file
        }
        return "unknown";
    }
    

    setData(){
        const{templateData} =  this.state;
        this.setState({
            loading: true
        })
        setTimeout(() => {
            if(document.getElementById('inside-html')){
                let fields = templateData['json_data']['fields'];
                let template = templateData['template'];
                const additional_files = templateData['additional_files'];


                document.getElementById('inside-html').innerHTML = sanitizeTemplateHtml(template);
                    setTimeout(() => {
                        let failedFields = [];
                        fields.map(_ => {
                            if (_.value && document.getElementById(_.id) && _.type != "file") {
                                // Get the old element
                                    const oldElement = document.getElementById(_.id);
    
                                    // Create a new label element
                                    const newLabel = document.createElement('label');
                                    newLabel.id = _.id;
                                    newLabel.textContent = _.value;
                                    newLabel.style.fontSize = "14px"
                                    oldElement.replaceWith(newLabel);
    
                                // document.getElementById(_.id).replaceWith(`<label id=${_.id}>${_.value}</label>`);
                                // document.getElementById(_.id).setAttribute('value', _.value)
                            } else if (_.value && document.getElementById(_.id) && _.type == 'file') {
                                document.getElementById(_.id).setAttribute('src', _.value)
                                document.getElementById(_.id).setAttribute('type', 'image')
                            } {
                                failedFields.push()
                            }
                        })
                        let allInputs = document.getElementById('inside-html').getElementsByTagName('input');
                        for (let index = 0; index < allInputs.length; ++index) {
                            allInputs[index].setAttribute('readOnly', true)
                            allInputs[index].setAttribute('disabled', true)
                        }

                        const contentDiv = document.getElementById('inside-html');
                        additional_files.forEach(base64 => {
                            const type = this.detectMimeType(base64);
                    
                            if (type === "image") {
                                const img = document.createElement('img');
                                img.src = `data:image/png;base64,${base64}`;
                                img.alt = "Base64 Image";
                                img.style.width = "100%"; // Adjust image size
                                contentDiv.appendChild(img);
                            } else if (type === "pdf") {
                                const embed = document.createElement('embed');
                                embed.src = `data:application/pdf;base64,${base64}`;
                                embed.type = "application/pdf";
                                embed.width = "100%";
                                embed.height = "500";
                                contentDiv.appendChild(embed);
                            } else {
                                const p = document.createElement('p');
                                p.textContent = "Unknown file type.";
                                contentDiv.appendChild(p);
                            }
                        });
                    


                        this.setState({
                            loading : false
                        })
                    },1000)
            }
        },1000)
            
    }

    // triggerEsign = () => {
    //     const{templateData} =  this.props;
    //     this.setState({
    //         loading: true
    //     })
    //     let payload = {
    //         'html' : document.getElementById('inside-html').innerHTML,
    //         "case_id": this.props.caseId,
    //         "json_data": templateData['json_data'],
    //         "road_map_id": templateData['road_map_id'],
    //         "additional_files" : templateData['additional_files'],
    //         "invitation_data": templateData["invitation_data"],
    //         "company_id" : this.props.companyId
    //     };

    //     if(this.props.dbAgreement){
    //         let data = {
    //             ...this.props.templateData,
    //             html : document.getElementById('inside-html').innerHTML,
    //             "company_id" : this.props.companyId

    //         }

    //         CaseLeegalityAgreementService.triggerDBEsign(data).then((response) => {
    //             message.success("E-sign Triggered Successfully")
    //             this.setState({
    //                 loading: false
    //             })
    //             this.props.handleEsignDrawer(true)
    //         }).catch((error) => {
    //             message.error("Failed to trigger E-sign")
    //             this.setState({
    //                 loading: false
    //             })
    //             console.log(error);
    //         })
    //     }else{
    //         CaseLeegalityAgreementService.triggerEsign(payload)
    //         .then((response) => {
    //             message.success("E-sign Triggered Successfully")
    //             this.setState({
    //                 loading: false
    //             })
    //             this.props.handleEsignDrawer(true)
    //             }).catch((error) => {
    //                 message.error("Failed to trigger E-sign")
    //                 this.setState({
    //                     loading: false
    //                 })
    //                 console.log(error);
    //         })
    //     }
    // }
 
    render() {
        return (
            // <Drawer
            //         visible={true}
            //         onClose={() => this.props.handleEsignDrawer()}
            //         width="100VW"
                    
            //     >
                    <Spin spinning={this.state.loading}>
                        <Row className="align-items-center p-10 bg-primary">
                            <Col span={24} >
                                <h1 style={{color: '#fff'}} className="text-align-center">PS-KIT Preview</h1>
                            </Col>
                            {/* <Col span={4}>
                                {this.props.showTriggerButton && <Button type="primary" onClick={() => this.triggerEsign()}>Trigger</Button>}
                            </Col> */}
                        </Row>
                        <Row>
                            <Button type="link" className="float-right" onClick={() => window.close()}>Close</Button>
                        </Row>
                        <div id="inside-html" style={{
                            height: "100vh",
                            overflowX : 'scroll',
                            userSelect: 'none'
                        }}>
                           
                        </div>
                    </Spin>
                //  </Drawer>
            
        )
    }
}